import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import IntegrationInfo from '../IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_StandaloneGuestServicePage_Integration,
  gAPI_Ingetration,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import Example from '../Example';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Layout from '../Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette, faFont, faBorderAll } from '@fortawesome/free-solid-svg-icons';
import StandaloneDigitalAssistant from './StandaloneDigitalAssistant';
import StandaloneCustomFonts from './StandaloneCustomFonts';
import StandaloneCodeSnippet from './StandaloneCodeSnippet';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

function StandaloneGuestServicePageIntegrationList({ match, history, propertyId }) {
  const integrationId = match.params.id;
  let [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [layoutVisible, setLayoutVisible] = useState(false);
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [fontsVisible, setFontsVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const property = () => {
    setPropertyVisible(true);
    setLayoutVisible(false);
    setPublishVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
  };
  const layout = () => {
    setPropertyVisible(false);
    setLayoutVisible(true);
    setPublishVisible(false);
    setApperanceVisible(false);
    setFontsVisible(false);
  };

  useEffect(() => {
    LoadIntegrationData();
  }, [integrationId]);
  const LoadIntegrationData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_StandaloneGuestServicePage_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  }
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);

  const saveIntegration = (data) => {
    const { list, name } = data;
    if (list === undefined && name === undefined && data) {
      integration.standalonePage = data;
    }
    if (list) {
      integration.properties = data.list;
    }
    if (name) {
      integration.name = name;
    }
    AxiosAPI({
      method: 'put',
      url: `${API_StandaloneGuestServicePage_Integration}/${integration.id}?group_id=${getGroupID()}`,
      data: integration,
    })
      .catch((err) => console.error(err))
      .then(() => {
        NotificationManager.success(
          "",
          "integration updated.",
          3000,
          null,
          null,
          "success"
        )
        setTimeout(() => {
          LoadIntegrationData()
        }, 500);
      });
  };

  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_SERVICE_URL}/gshp?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const publishCode = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setPublishVisible(true);
    setApperanceVisible(false);
    setFontsVisible(false);
  };


  const appearance = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setPublishVisible(false);
    setApperanceVisible(true);
    setFontsVisible(false);
  };
  const setFonts = () => {
    setPropertyVisible(false);
    setLayoutVisible(false);
    setApperanceVisible(false);
    setFontsVisible(true);
    setPublishVisible(false);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/applications');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/applications' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.select_properties' />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id='integration.select_properties_enabled' />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${layoutVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-building`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => layout()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select layout
                          </p>
                          <p className="mb-4 text-small">
                            Select the layout that are visible through this
                            integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>

                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id='integration.appearance' />
                          </p>
                          <p className="mb-4 text-small">
                            Choose your page layout, colors, and fonts
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${fontsVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFont} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFonts()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Custom Fonts
                          </p>
                          <p className="mb-4 text-small">
                            Upload any custom fonts you might want to use for the page
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Publish your Guest Services page
                          </p>
                          <p className="mb-4 text-small">
                            Copy your unique URL, and generate QR code
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {apperanceVisible && (
                <Fragment>
                  <StandaloneDigitalAssistant
                    botSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />
                </Fragment>
              )}
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" />
                </Fragment>
              )}
              {fontsVisible && (
                <Fragment>
                  <StandaloneCustomFonts
                    botSettings={integration.standalonePage.pageSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" />
                </Fragment>
              )}
              {publishVisible &&
                <Fragment>
                  <StandaloneCodeSnippet propertyId={propertyId} integration={integration} />
                  <Card>
                    <CardBody>
                      <div className="text-center">
                        <iframe
                          src={"https://pages.bookmebob.com/qr-code"}
                          alt="example"
                          width="100%"
                          style={{ height: "40rem" }}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Fragment>}
              {layoutVisible && (
                <Fragment>
                  <Layout
                    pageSettings={integration.standalonePage.pageSettings}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId
  };
};

export default injectIntl(connect(mapStateToProps, {})(StandaloneGuestServicePageIntegrationList));
